import { useSearchParams } from 'react-router-dom'
import React from 'react'
import { ViewLayoutType } from '../../../config/types'

export const useProductViewLayout = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const view = searchParams.get('view')
  const [viewLayout, _setViewLayout] = React.useState((view as ViewLayoutType) ?? ViewLayoutType.list)

  const setViewLayout = (value: ViewLayoutType) => {
    _setViewLayout(value)

    //we need to set also the params
    setSearchParams((prev) => ({ ...Object.fromEntries(prev), view: value }))
  }

  return {
    viewLayout,
    setViewLayout,
  }
}
